<p-tag
  [value]="orderStatus"
  [severity]="getOrderStatusSeverity(orderStatus)"
  icon="pi pi-circle-fill"
  styleClass="mb-2"
  data-cy="order-status-tag"
>
</p-tag>

<!-- TODO Restore this version when we are showing status descriptions
  <p-tag
    *ngIf="!!order.status && (isTouchDevice$ | async) === false"
    [value]="order.status"
    [severity]="getOrderStatusSeverity(order.status)"
    icon="pi pi-circle-fill"
    [pTooltip]="order.statusDescription"
    tooltipPosition="bottom"
    styleClass="cursor-pointer"
  >
  </p-tag>

  <p-tag
    *ngIf="!!order.status && (isTouchDevice$ | async) === true"
    [value]="order.status"
    [severity]="getOrderStatusSeverity(order.status)"
    icon="pi pi-circle-fill"
    [pTooltip]="order.statusDescription"
    tooltipEvent="focus"
    [tabindex]="0"
    tooltipPosition="bottom"
    styleClass="cursor-pointer"
  >
  </p-tag>
-->
